import React from 'react';
import { X } from 'lucide-react';
import { Logo } from '../../atoms/Logo';

export interface SidebarHeaderProps {
  onClose?: () => void;
  showCloseButton?: boolean;
}

export const SidebarHeader = ({
  onClose,
  showCloseButton = false,
}: SidebarHeaderProps) => {
  return (
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <Logo size="medium" />
        {showCloseButton && onClose && (
          <button
            onClick={onClose}
            className="lg:hidden text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        )}
      </div>
    </div>
  );
};

